import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EditProfileModalService {
  readonly modalVisible = signal(false);

  constructor() {}

  open() {
    this.modalVisible.set(true);
  }

  close() {
    this.modalVisible.set(false);
  }
}
